export class VivoChangeEvent {
  constructor(public vivoBody: VivoBody) {}
}

export class VivoBody {
  page: number;
  limit: number;
  filters?: Filters[];
  viewOptions?: {
    onlyCommented?: boolean,
    onlyMine?: boolean,
    onlyPending?: boolean,
    orderby: string,
    reverse: boolean,
    withLastMessage?: boolean,
    withMessageCount?: boolean
  };

  constructor() {
    this.page = 1;
    this.limit = 50;
    this.filters = [];
    this.viewOptions = {
      orderby: 'updatedAt',
      reverse: false
    };
  }
}
export interface Filters {
  property?: Property;
  option?: {value: string, name?: string};
  query?: {key: string, value: string}[];
  value?: string | {name: string, value: number} | {name?: string,  _id: string | number}[];
}

export interface Property extends Filters {
  label?: string;
  _id?: string;
  type?: string;
}
